import { h, Fragment } from "preact";
import ProductOptionPill from "./product-option-pill";
import ProductOptionInlineHeader from "./product-option-inline-header";
import ProductOptionSizeNote from "./product-option-size-note";

export default function ProductOptionPillsInline({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  variantsByOptionValue = [],
  unavailableOptionValues = [],
  waitlistOptionValues = [],
  last,
  optionSize,
  sizeNote,
}) {
  const maxValueLength = Math.max(
    ...optionValues.map((optionValue) => optionValue.name.length),
  );
  const maxColumns = maxValueLength > 15 ? 2 : maxValueLength > 10 ? 3 : 4;
  const pillColumns = Math.min(optionValues.length, maxColumns);

  return (
    <div
      className={`product-options__option-inline ${last ? "product-options__option-inline--last" : ""} product-options__pills-inline`}
    >
      <ProductOptionInlineHeader
        optionName={optionName}
        selectedOptionValue={selectedOptionValue}
      />
      <fieldset
        className="product-options__pill-list"
        style={{ "--pill-columns": pillColumns }}
      >
        <legend className="visually-hidden">{optionName}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionPill
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            optionVariant={variantsByOptionValue.find(
              (variantByOptionValue) =>
                variantByOptionValue.optionValue === optionValue.name,
            )}
            unavailable={unavailableOptionValues.includes(optionValue.name)}
            waitlist={waitlistOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
            optionSize={optionSize}
          />
        ))}
      </fieldset>
      <ProductOptionSizeNote sizeNote={sizeNote} />
    </div>
  );
}
